import { Component, OnInit } from '@angular/core';
import { NavService } from '../../../_services/_nav.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Alerta } from '../../../_models/alerta';
import { AlertaService } from '../../../_services/alerta.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { Location } from '@angular/common';
import { AlertaPerfilRiesgoService } from '../../../_services/alerta-perfil-riesgo.service';
import { AlertaEstructuraFisicaService } from '../../../_services/alerta-estructura-fisica.service';
import { AlertaTipoVinculacionService } from '../../../_services/alerta-tipo-vinculacion.service';
import { AlertaPerfilRiesgo } from '../../../_models/alerta-perfil-riesgo';
import { AlertaEstructuraFisica } from '../../../_models/alerta-estructura-fisica';
import { AlertaTipoVinculacion } from '../../../_models/alerta-tipo-vinculacion';
import { PerfilRiesgoService } from '../../../_services/perfil-riesgo.service';
import { EstructuraFisicaService } from '../../../_services/estructura-fisica.service';
import { ListaService } from '../../../_services/lista.service';
import { forkJoin } from 'rxjs';
import { EstadoService } from '../../../_services/estado.service';
import { NivelesService } from '../../../_services/niveles.service';
import { AlertaDetalleService } from '../../../_services/alerta-detalle.service';
import { AlertaAprobacionService } from '../../../_services/alerta-aprobacion.service';
import { AlertaDescarteService } from '../../../_services/alerta-descarte.service';
import { AlertaDetalle } from '../../../_models/alerta-detalle';
import { AlertaAprobacion } from '../../../_models/alerta-aprobacion';
import { AlertaDescarte } from '../../../_models/alerta-descarte';
import { AlertaExcepcion } from '../../../_models/alerta-excepcion';
import { AlertaExcepcionService } from '../../../_services/alerta-excepcion.service';

@Component( {
  selector: 'app-alerta-editar',
  templateUrl: 'alerta-editar.component.html'
} )

export class AlertaEditarComponent implements OnInit {

  carInformacionInicial = true;
  codExiste = false;
  guardando = false;
  submitted = false;
  lisAlertas: Alerta[];
  alerta: Alerta;
  regPerfiles: AlertaPerfilRiesgo[] = [];
  regEstructurasFisicas: AlertaEstructuraFisica[] = [];
  regVinculaciones: AlertaTipoVinculacion[] = [];
  detalle: AlertaDetalle;
  aprobacion: AlertaAprobacion;
  descarte: AlertaDescarte;
  lisPerfiles: SelectItem[] = [];
  lisEstructurasFisicas: SelectItem[] = [];
  lisVinculaciones: SelectItem[] = [];
  lisNotaInterna: SelectItem[] = [];
  lisTiposAlertas: SelectItem[] = [];
  lisNiveles: SelectItem[] = [];
  lisEstados: SelectItem[] = [];
  lisCausales: SelectItem[] = [];
  formulario: FormGroup;
  excepcion: AlertaExcepcion;


  constructor( private alerServicio: AlertaService,
               private alePerfilesRiesgosServicio: AlertaPerfilRiesgoService,
               private aleEstructurasFisicasServicio: AlertaEstructuraFisicaService,
               private aleTiposVinculacionesServicio: AlertaTipoVinculacionService,
               private aleDetalleServicio: AlertaDetalleService,
               private aleAprobacionServicio: AlertaAprobacionService,
               private aleDescarteServicio: AlertaDescarteService,
               private perRiesgosServicio: PerfilRiesgoService,
               private estFisicasServicio: EstructuraFisicaService,
               private estadosServicio: EstadoService,
               private nivelesServicio: NivelesService,
               private lisServicio: ListaService,
               private navServicio: NavService,
               private conServicio: ConfirmationService,
               private location: Location,
               private router: Router,
               private formBuilder: FormBuilder,
               private route: ActivatedRoute,
               private alertaExcepcionService: AlertaExcepcionService ) {
  }

  ngOnInit(): void {
    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        this.alerServicio.obtenerPorId( params[ 'id' ] ).subscribe( alerta => {
          this.alerta = alerta;
          forkJoin( this.alePerfilesRiesgosServicio.obtenerPorIdAlerta( this.alerta.idAlerta ),
            this.aleEstructurasFisicasServicio.obtenerPorIdAlerta( this.alerta.idAlerta ),
            this.aleTiposVinculacionesServicio.obtenerPorIdAlerta( this.alerta.idAlerta ),
            this.aleDetalleServicio.obtenerPorIdAlerta( this.alerta.idAlerta ),
            this.aleDescarteServicio.obtenerPorIdAlerta( this.alerta.idAlerta ),
            this.alertaExcepcionService.obtenerPorIdAlerta( this.alerta.idAlerta ) )
            .subscribe( ( [perfiles, estFisicas, tipVinculacion, detalle, descarte, excepcion] ) => {
              this.regPerfiles = perfiles;
              this.regEstructurasFisicas = estFisicas;
              this.regVinculaciones = tipVinculacion;
              this.detalle = detalle[ 0 ];
              this.descarte = descarte ? descarte : null;
              this.excepcion = (excepcion && excepcion.length > 0) ? excepcion[ 0 ] : null;
              this.carServicios();
            } );
        } );
      } else {
        this.carServicios();
      }
    } );
  }

  get f() {
    return this.formulario.controls;
  }

  carServicios() {
    this.formulario = this.formBuilder.group( {
      idAlerta: [this.alerta ? this.alerta.idAlerta : null],
      codigo: [this.alerta ? this.alerta.codigo : null, [Validators.required, Validators.maxLength( 10 )]],
      nombre: [this.alerta ? this.alerta.nombre : null, [Validators.required, Validators.maxLength( 100 )]],
      idTipoAlerta: [this.alerta ? this.alerta.idTipoAlerta : null, [Validators.required]],
      descripcion: [this.alerta ? this.alerta.descripcion : null, Validators.required],
      idPerfil: [this.regPerfiles && this.regPerfiles.length > 0 ? this.regPerfiles.filter( r => r.indicadorHabilitado ).map( r => {
        return r.idPerfilRiesgo;
      } ) : []],
      idOficina: [this.regEstructurasFisicas && this.regEstructurasFisicas.length > 0 ? this.regEstructurasFisicas
        .filter( r => r.indicadorHabilitado ).map( r => {
          return r.idEstructuraFisica;
        } ) : []],
      notaInterna: [this.detalle ? this.detalle.notaInterna : null],
      idTipoVinculacion: [this.regVinculaciones && this.regVinculaciones.length > 0 ? this.regVinculaciones
        .filter( r => r.indicadorHabilitado ).map( r => {
          return r.idTipoVinculacion;
        } ) : []],
      indicadorAlertaInterna: [this.alerta ? this.alerta.indicadorAlertaInterna : false, [Validators.required]],
      indicadorTodosLosperfiles: [false],
      indicadorTodasOficinas: [false],
      indicadorNuevoCredito: [this.detalle ? this.detalle.indicadorNuevoCredito : false],
      indicadorRenuevaCredito: [this.detalle ? this.detalle.indicadorRenuevaCredito : false],
      descartarAlerta: [this.descarte && this.descarte.indicadorHabilitado ? 'descartar' : 'alerta'],
      idNivel: [this.excepcion ? this.excepcion.idNivel : null, this.excepcion ? [Validators.required] : null],
      idEstado: [this.descarte ? this.descarte.idEstado : null, this.descarte ? [Validators.required] : null],
      idTipoCausalSolicitud: [this.descarte ? this.descarte.idCausalSolicitud : null, this.descarte ? [Validators.required] : null],
      indicadorHabilitado: [this.alerta ? this.alerta.indicadorHabilitado : true],
      indicadorExcepcion: [(this.excepcion && this.excepcion.indicadorHabilitado) ? true : false],
      indicadorManejaAdjunto: [(this.excepcion && this.excepcion.indicadorHabilitado) ? this.excepcion.indicadorManejaAdjunto : false],
      descripcionExcepcion: [(this.excepcion && this.excepcion.indicadorHabilitado) ? this.excepcion.descripcion : null, (this.excepcion && this.excepcion.indicadorHabilitado) ? [Validators.required] : null],
    } );
    forkJoin( this.alerServicio.listado(),
      this.perRiesgosServicio.listadoHabilitados(),
      this.estFisicasServicio.getAllEnabled(),
      this.lisServicio.getMasterDetails( 'ListasTiposVinculaciones' ),
      this.nivelesServicio.listado(),
      this.estadosServicio.listadoHabilitados(),
      this.lisServicio.getMasterDetails( 'ListasCausalesSolicitudes' ),
      this.lisServicio.getMasterDetails( 'ListasTiposAlertas' ) )
      .subscribe( ( [alertas, perfiles, estructurasFisicas, tiposVinculaciones, niveles, estados, causales, tiposAlertas] ) => {
        this.lisAlertas = alertas;
        this.lisPerfiles = perfiles.map( p => {
          return { label: p.nombreRiesgo, value: p.idPerfilRiesgo };
        } );
        this.lisEstructurasFisicas = estructurasFisicas.map( ef => {
          return { label: ef.estructuraFisica, value: ef.idEstructuraFisica };
        } );
        this.lisVinculaciones = tiposVinculaciones.map( tv => {
          return { label: tv.nombre, value: tv.idLista };
        } );
        this.lisNotaInterna = [1, 2, 3, 4, 5].map( n => {
          return { label: String( n ), value: n };
        } );
        this.lisNiveles = niveles.filter( n => n.indicadorHabilitado ).map( n => {
          return { label: n.nombre, value: n.idNivel };
        } );
        this.lisEstados = estados.map( e => {
          return { label: e.nombre, value: e.idEstado };
        } );
        this.lisCausales = causales.map( c => {
          return { label: c.nombre, value: c.idLista };
        } );
        this.lisTiposAlertas = tiposAlertas.map( ta => {
          return { label: ta.nombre, value: ta.idLista };
        } );
        this.f.indicadorTodosLosperfiles.setValue( perfiles
          .filter( p => !this.regPerfiles.find( rp => rp.idPerfilRiesgo === p.idPerfilRiesgo ) ).length === 0 );
        this.f.indicadorTodasOficinas.setValue( estructurasFisicas
          .filter( e => !this.regEstructurasFisicas.find( re => re.idEstructuraFisica === e.idEstructuraFisica ) ).length === 0 );
        this.carInformacionInicial = false;
      } );
  }

  cambiar( valor: string ) {
    switch ( valor ) {
      case 'alerta':
        this.f.idNivel.clearValidators();
        this.f.idEstado.clearValidators();
        this.f.idTipoCausalSolicitud.clearValidators();
        this.f.idNivel.setErrors( null );
        this.f.idEstado.setErrors( null );
        this.f.idTipoCausalSolicitud.setErrors( null );
        this.f.idNivel.setValidators( [Validators.required] );
        this.f.idEstado.setValidators( null );
        this.f.idTipoCausalSolicitud.setValidators( null );
        //this.redefinirFormulario();
        break;
      case 'descartar':
        this.f.idNivel.clearValidators();
        this.f.idEstado.setValidators( [Validators.required] );
        this.f.idTipoCausalSolicitud.setValidators( [Validators.required] );
        this.f.idNivel.setErrors( null );
        this.f.idEstado.setErrors( null );
        this.f.idTipoCausalSolicitud.setErrors( null );
        this.f.idNivel.setValidators( null );
        this.f.idEstado.setValidators( [Validators.required] );
        this.f.idTipoCausalSolicitud.setValidators( [Validators.required] );
        //this.redefinirFormulario(true);
        break;
    }
  }

  cambiarAlertaInterna( valor: boolean ) {
    this.f.indicadorTodosLosperfiles.clearValidators();
    this.f.idPerfil.clearValidators();
    this.f.indicadorTodasOficinas.clearValidators();
    this.f.idOficina.clearValidators();
    this.f.notaInterna.clearValidators();
    this.f.indicadorNuevoCredito.clearValidators();
    this.f.indicadorRenuevaCredito.clearValidators();
    this.f.indicadorTodosLosperfiles.setErrors( null );
    this.f.idPerfil.setErrors( null );
    this.f.indicadorTodasOficinas.setErrors( null );
    this.f.idOficina.setErrors( null );
    this.f.notaInterna.setErrors( null );
    this.f.indicadorNuevoCredito.setErrors( null );
    this.f.indicadorRenuevaCredito.setErrors( null );
    this.f.indicadorTodosLosperfiles.setValidators( null );
    this.f.idPerfil.setValidators( null );
    this.f.indicadorTodasOficinas.setValidators( null );
    this.f.idOficina.setValidators( null );
    this.f.notaInterna.setValidators( null );
    this.f.notaInterna.setValidators( null );
    this.f.indicadorNuevoCredito.setValidators( null );
    this.f.indicadorRenuevaCredito.setValidators( null );
    if ( valor ) {
      this.f.indicadorTodosLosperfiles.setValue( false );
      this.f.idPerfil.setValue( [] );
      this.f.idNivel.setValidators( null );
      this.f.indicadorTodasOficinas.setValue( false );
      this.f.idOficina.setValue( [] );
      this.f.notaInterna.setValue( null );
      //this.f.idTipoVinculacion.setValue( [] );
      this.f.indicadorNuevoCredito.setValue( false );
      this.f.indicadorRenuevaCredito.setValue( false );
    } else {
      this.f.indicadorTodosLosperfiles.setValue( this.lisPerfiles
        .filter( p => !this.regPerfiles.find( rp => rp.idPerfilRiesgo === p.value ) ).length !== 0 );
      this.f.indicadorTodasOficinas.setValue( this.lisEstructurasFisicas
        .filter( e => !this.regEstructurasFisicas.find( re => re.idEstructuraFisica === e.value ) ).length !== 0 );
      this.f.idPerfil.setValue( this.regPerfiles && this.regPerfiles.length > 0 ?
        this.regPerfiles.filter( r => r.indicadorHabilitado ).map( r => {
          return r.idPerfilRiesgo;
        } ) : [] );
      this.f.idOficina.setValue( this.regEstructurasFisicas && this.regEstructurasFisicas.length > 0 ? this.regEstructurasFisicas
        .filter( r => r.indicadorHabilitado ).map( r => {
          return r.idEstructuraFisica;
        } ) : [] );
      this.f.notaInterna.setValue( this.detalle ? this.detalle.notaInterna : null );
      /*this.f.idTipoVinculacion.setValue( this.regVinculaciones && this.regVinculaciones.length > 0 ? this.regVinculaciones
        .filter( r => r.indicadorHabilitado ).map( r => {
          return r.idTipoVinculacion;
        } ) : [] );*/
      this.f.indicadorNuevoCredito.setValue( this.detalle ? this.detalle.indicadorNuevoCredito : null );
      this.f.indicadorRenuevaCredito.setValue( this.detalle ? this.detalle.indicadorRenuevaCredito : null );
    }
  }

  seleccionarTodos( valor: string, tipo: string ) {
    switch ( `${valor}-${tipo}` ) {
      case 'true-perfiles':
        this.f.idPerfil.setValue( this.lisPerfiles.map( lp => {
          return lp.value;
        } ) );
        break;
      case 'false-perfiles':
        this.f.idPerfil.setValue( [] );
        break;
      case 'true-oficinas':
        this.f.idOficina.setValue( this.lisEstructurasFisicas.map( ef => {
          return ef.value;
        } ) );
        break;
      case 'false-oficinas':
        this.f.idOficina.setValue( [] );
        break;
    }
  }

  validarCodigo() {
    this.codExiste = !!this.lisAlertas.find( x => x.codigo === this.f.codigo.value );
  }

  async onSubmit() {
    this.submitted = true;
    if ( !this.codExiste && this.formulario.valid ) {
      this.guardando = true;
      if ( this.alerta && this.alerta.idAlerta ) {
        if ( this.validateAlerta() ) {
          this.alerta.nombre = this.f.nombre.value;
          this.alerta.codigo = this.f.codigo.value;
          this.alerta.descripcion = this.f.descripcion.value;
          this.alerta.indicadorAlertaInterna = this.f.indicadorAlertaInterna.value;
          this.alerta.idTipoAlerta = this.f.idTipoAlerta.value;
          this.alerta.indicadorHabilitado = this.f.indicadorHabilitado.value;
          this.alerServicio.actualizar( this.alerta ).subscribe( async( alerta ) => {
            this.alerta = alerta;
            await this.guardarDetalle();
            await this.guardarPerfilesOficinasVinculaciones();
            await this.guardarAlertaDescarte();
            //await this.guardarExcepcionAlerta();
          } );
        } else {
          this.submitted = false;
          this.guardando = false;
          return;
        }
      } else {
        const nueAlerta: Alerta = {} as Alerta;
        nueAlerta.nombre = this.f.nombre.value;
        nueAlerta.codigo = this.f.codigo.value;
        nueAlerta.descripcion = this.f.descripcion.value;
        nueAlerta.indicadorAlertaInterna = this.f.indicadorAlertaInterna.value;
        nueAlerta.idTipoAlerta = this.f.idTipoAlerta.value;
        nueAlerta.indicadorHabilitado = this.f.indicadorHabilitado.value;
        this.alerServicio.crear( nueAlerta ).subscribe( async( alerta ) => {
          this.alerta = alerta;
          await this.guardarDetalle();
          await this.guardarPerfilesOficinasVinculaciones();
          await this.guardarAlertaDescarte();
          //await this.guardarExcepcionAlerta();
        } );
      }
    } else {
      return;
    }
  }

  async validateAlerta() {
    if ( !this.f.indicadorHabilitado.value ) {
      await  this.alerServicio.alertaProducto( this.alerta.idAlerta ).subscribe( ( data: any[] ) => {
        if ( data && data.length > 0 ) {
          this.f.indicadorHabilitado.setValue( true );
          this.navServicio.setMesage( 0, {
            severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navServicio.buscarMensaje( 'ALERTAS.MSG_PRODUCTOALERTA' ) + data.join( ',' )
          } );
          return false;
        } else {
          return true;
        }
      } );
    } else {
      return true;
    }

  }

  async guardarDetalle() {
    if ( this.detalle && this.detalle.idAlertaDetalle ) {
      if ( !this.alerta.indicadorAlertaInterna ) {
        this.detalle.idAlerta = this.alerta.idAlerta;
        this.detalle.notaInterna = this.f.notaInterna.value;
        this.detalle.indicadorNuevoCredito = this.f.indicadorNuevoCredito.value;
        this.detalle.indicadorRenuevaCredito = this.f.indicadorRenuevaCredito.value;
        this.detalle.indicadorHabilitado = true;
      } else {
        this.detalle.indicadorHabilitado = false;
      }
      await this.aleDetalleServicio.actualizar( this.detalle ).subscribe( detalle => {
        this.detalle = detalle;
      } );
    } else {
      if ( !this.alerta.indicadorAlertaInterna ) {
        const nueDetalle: AlertaDetalle = {} as AlertaDetalle;
        nueDetalle.idAlerta = this.alerta.idAlerta;
        nueDetalle.notaInterna = this.f.notaInterna.value;
        nueDetalle.indicadorNuevoCredito = this.f.indicadorNuevoCredito.value;
        nueDetalle.indicadorRenuevaCredito = this.f.indicadorRenuevaCredito.value;
        nueDetalle.indicadorHabilitado = true;
        await this.aleDetalleServicio.crear( nueDetalle ).subscribe( detalle => {
          this.detalle = detalle;
        } );
      }
    }
  }

  async guardarPerfilesOficinasVinculaciones() {
    if ( !this.alerta.indicadorAlertaInterna ) {
      this.regPerfiles.filter( r => !this.f.idPerfil.value
        .find( p => r.idPerfilRiesgo === p ) ).forEach( r => r.indicadorHabilitado = false );
      this.regPerfiles.filter( r => this.f.idPerfil.value
        .find( p => r.idPerfilRiesgo === p ) ).forEach( r => r.indicadorHabilitado = true );
      this.f.idPerfil.value.filter( p => !this.regPerfiles.find( r => r.idPerfilRiesgo === p ) ).forEach( p => {
        const temp: AlertaPerfilRiesgo = {} as AlertaPerfilRiesgo;
        temp.idAlerta = this.alerta.idAlerta;
        temp.idPerfilRiesgo = p;
        temp.indicadorHabilitado = true;
        this.regPerfiles.push( temp );
      } );
      this.regEstructurasFisicas.filter( r => !this.f.idOficina.value
        .find( o => r.idEstructuraFisica === o ) ).forEach( r => r.indicadorHabilitado = false );
      this.regEstructurasFisicas.filter( r => this.f.idOficina.value
        .find( o => r.idEstructuraFisica === o ) ).forEach( r => r.indicadorHabilitado = true );
      this.f.idOficina.value.filter( o => !this.regEstructurasFisicas.find( r => r.idEstructuraFisica === o ) ).forEach( o => {
        const temp: AlertaEstructuraFisica = {} as AlertaEstructuraFisica;
        temp.idAlerta = this.alerta.idAlerta;
        temp.idEstructuraFisica = o;
        temp.indicadorHabilitado = true;
        this.regEstructurasFisicas.push( temp );
      } );
      /*this.regVinculaciones.filter( r => !this.f.idTipoVinculacion.value
        .find( v => r.idTipoVinculacion === v ) ).forEach( r => r.indicadorHabilitado = false );
      this.regVinculaciones.filter( r => this.f.idTipoVinculacion.value
        .find( v => r.idTipoVinculacion === v ) ).forEach( r => r.indicadorHabilitado = true );
      this.f.idTipoVinculacion.value.filter( v => !this.regVinculaciones.find( r => r.idTipoVinculacion === v ) ).forEach( v => {
        const temp: AlertaTipoVinculacion = {} as AlertaTipoVinculacion;
        temp.idAlerta = this.alerta.idAlerta;
        temp.idTipoVinculacion = v;
        temp.indicadorHabilitado = true;
        this.regVinculaciones.push( temp );
      } );*/
    } else {
      this.regPerfiles.forEach( r => r.indicadorHabilitado = false );
      this.regEstructurasFisicas.forEach( r => r.indicadorHabilitado = false );
      //this.regVinculaciones.forEach( r => r.indicadorHabilitado = false );
    }
    this.armarListaVinculaciones();
    await forkJoin( this.alePerfilesRiesgosServicio.bulk( this.regPerfiles ),
      this.aleEstructurasFisicasServicio.bulk( this.regEstructurasFisicas ),
      this.aleTiposVinculacionesServicio.bulk( this.regVinculaciones ) ).subscribe( async( [perfiles, oficinas, vinculaciones] ) => {
      this.regPerfiles = perfiles;
      this.regEstructurasFisicas = oficinas;
      this.regVinculaciones = vinculaciones;
    } );
  }

  private armarListaVinculaciones(){
    this.regVinculaciones.filter( r => !this.f.idTipoVinculacion.value
      .find( v => r.idTipoVinculacion === v ) ).forEach( r => r.indicadorHabilitado = false );
    this.regVinculaciones.filter( r => this.f.idTipoVinculacion.value
      .find( v => r.idTipoVinculacion === v ) ).forEach( r => r.indicadorHabilitado = true );
    this.f.idTipoVinculacion.value.filter( v => !this.regVinculaciones.find( r => r.idTipoVinculacion === v ) ).forEach( v => {
      const temp: AlertaTipoVinculacion = {} as AlertaTipoVinculacion;
      temp.idAlerta = this.alerta.idAlerta;
      temp.idTipoVinculacion = v;
      temp.indicadorHabilitado = true;
      this.regVinculaciones.push( temp );
    } );
  }

  async guardarAlertaDescarte() {
    switch ( this.f.descartarAlerta.value ) {
      case 'alerta':
        if ( this.descarte && this.descarte.idAlertaDescarte ) {
          this.descarte.indicadorHabilitado = false;
          await this.aleDescarteServicio.actualizar( this.descarte ).subscribe();
        }
        if ( this.descarte && !this.descarte.indicadorHabilitado ) {
          await this.guardarExcepcionAlerta();
          this.submitted = false;
          this.finalizar( false );
        } else {
          const nueAprobacion: AlertaAprobacion = {} as AlertaAprobacion;
          nueAprobacion.idAlerta = this.alerta.idAlerta;
          nueAprobacion.idNivel = this.f.idNivel.value;
          nueAprobacion.indicadorHabilitado = true;
          await this.guardarExcepcionAlerta();
          this.submitted = false;
          this.finalizar( true );
        }
        break;
      case 'descartar':
        if ( this.descarte && this.descarte.idAlertaDescarte ) {
          this.descarte.idEstado = this.f.idEstado.value;
          this.descarte.idCausalSolicitud = this.f.idTipoCausalSolicitud.value;
          this.descarte.indicadorHabilitado = true;
          await this.aleDescarteServicio.actualizar( this.descarte ).subscribe( async( descarte ) => {
            await this.guardarExcepcionAlerta();
            this.submitted = false;
            this.descarte = descarte;
            this.finalizar( false );
          } );
        } else {
          const nueDescartar: AlertaDescarte = {} as AlertaDescarte;
          nueDescartar.idAlerta = this.alerta.idAlerta;
          nueDescartar.idEstado = this.f.idEstado.value;
          nueDescartar.idCausalSolicitud = this.f.idTipoCausalSolicitud.value;
          nueDescartar.indicadorHabilitado = true;
          await this.aleDescarteServicio.crear( nueDescartar ).subscribe( async( descarte ) => {
            await this.guardarExcepcionAlerta();
            this.submitted = false;
            this.descarte = descarte;
            this.finalizar( true );
          } );
        }
        break;
    }
  }

  finalizar( nuevo: boolean ) {
    if ( nuevo ) {
      this.guardando = false;
      this.navServicio.setMesage( 1, {} );
      this.router.navigate( [`apl/alertas/actualizar/${this.alerta.idAlerta}`] );
    } else {
      this.guardando = false;
      this.navServicio.setMesage( 2, {} );
    }
  }

  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.router.navigate( [`apl/alertas/`] );
        },
        reject: () => {
        }
      } );
    } else {
      this.router.navigate( [`apl/alertas/`] );
    }
  }

  confirmarGuardado() {
    this.conServicio.confirm( {
      message: this.navServicio.buscarMensaje( 'MSG_GUARDAR' ),
      header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      accept: () => {
        this.onSubmit();
      },
      reject: () => {
      }
    } );
  }

  redefinirFormulario( validarAlerta: boolean = false ) {
    if ( validarAlerta || !this.f.indicadorExcepcion.value ) {
      this.f.indicadorManejaAdjunto.reset( false );
      this.f.descripcionExcepcion.setValidators( [] );
      this.f.descripcionExcepcion.reset( null );
      this.f.idNivel.setValidators( [] );
      this.f.idNivel.reset( null );
    } else {
      this.f.indicadorManejaAdjunto.reset( this.excepcion ? this.excepcion.indicadorManejaAdjunto : false );
      this.f.descripcionExcepcion.setValidators( [Validators.required] );
      this.f.idNivel.setValidators( [Validators.required] );
      this.f.descripcionExcepcion.reset( this.excepcion ? this.excepcion.descripcion : null );
      this.f.descripcionExcepcion.updateValueAndValidity();
      this.f.idNivel.setValidators( [Validators.required] );
      this.f.idNivel.setValue( this.excepcion ? this.excepcion.idNivel : null );
      this.f.idNivel.updateValueAndValidity();
    }
  }

  async guardarExcepcionAlerta() {
    if ( this.f.descartarAlerta.value === 'alerta' ) {
      if ( this.excepcion ) {
        //Editar
        const excEditar: AlertaExcepcion = {} as AlertaExcepcion;
        if ( this.f.indicadorExcepcion.value ) {
          excEditar.idAlerta = this.excepcion.idAlerta;
          excEditar.indicadorManejaAdjunto = this.f.indicadorManejaAdjunto.value;
          excEditar.descripcion = this.f.descripcionExcepcion.value;
          excEditar.indicadorHabilitado = true;
          excEditar.idAlertaExcepcion = this.excepcion.idAlertaExcepcion;
          excEditar.idNivel = this.f.idNivel.value;
        } else {
          excEditar.idAlerta = this.excepcion.idAlerta;
          excEditar.indicadorManejaAdjunto = this.excepcion.indicadorManejaAdjunto;
          excEditar.descripcion = this.excepcion.descripcion;
          excEditar.indicadorHabilitado = false;
          excEditar.idAlertaExcepcion = this.excepcion.idAlertaExcepcion;
          excEditar.idNivel = this.excepcion.idNivel;
        }

        await this.alertaExcepcionService.actualizar( excEditar ).subscribe( res => {
          this.excepcion = res;
        } );

      } else {
        if ( this.f.indicadorExcepcion.value && !this.excepcion ) {
          //guardar
          const nuevaExcepcion: AlertaExcepcion = {} as AlertaExcepcion;
          nuevaExcepcion.idAlerta = this.alerta.idAlerta;
          nuevaExcepcion.indicadorManejaAdjunto = this.f.indicadorManejaAdjunto.value;
          nuevaExcepcion.descripcion = this.f.descripcionExcepcion.value;
          nuevaExcepcion.indicadorHabilitado = true;
          nuevaExcepcion.idNivel = this.f.idNivel.value;
          await this.alertaExcepcionService.crear( nuevaExcepcion ).subscribe( res => {
            this.excepcion = res;
          } );
        }
      }
    } else if ( this.f.descartarAlerta.value === 'descartar' ) {
      if ( this.excepcion ) {
        //Editar
        const excEditar: AlertaExcepcion = {} as AlertaExcepcion;
        //if ( this.excepcion.indicadorHabilitado ) {
        excEditar.idAlerta = this.excepcion.idAlerta;
        excEditar.indicadorManejaAdjunto = this.excepcion.indicadorManejaAdjunto;
        excEditar.descripcion = this.excepcion.descripcion;
        excEditar.indicadorHabilitado = false;
        excEditar.idAlertaExcepcion = this.excepcion.idAlertaExcepcion;
        excEditar.idNivel = this.excepcion.idNivel;
        //}

        await this.alertaExcepcionService.actualizar( excEditar ).subscribe( res => {
          this.excepcion = res;
        } );

      }
    }
  }
}
